import { createRouter } from '@tanstack/react-router'
import type { RouterHistory } from '@tanstack/react-router'
import { createElement } from 'react'
import { LoadingSkeleton } from './components/loading-skeleton'
import { captureRouteError } from './lib/sentry'
import { routeTree } from './routeTree.gen'

export function createAppRouter(history?: RouterHistory) {
  return createRouter({
    routeTree,
    history,
    // Route error boundaries catch render errors before Sentry's global handler sees them.
    defaultOnCatch: captureRouteError,
    // Each route's code is its own chunk (autoCodeSplitting). Fetch it on hover or touch, so the
    // chunk is usually there by the click; otherwise the router holds the old page until it lands.
    defaultPreload: 'intent',
    // A chunk still loading after 150ms shows a skeleton in the page's place instead of the
    // frozen old page (the default waits 1s).
    defaultPendingMs: 150,
    defaultPendingMinMs: 200,
    defaultPendingComponent: () => createElement(LoadingSkeleton, { variant: 'page' }),
  })
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createAppRouter>
  }

  // A route that names itself in the shell's breadcrumb sets staticData.breadcrumb to an
  // i18n key (components/app-shell/app-shell.tsx).
  interface StaticDataRouteOption {
    breadcrumb?: string
  }
}
